var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#3fa9e1;}.cls-3{fill:#0094bc;}.cls-4{fill:#70c6d2;}.cls-5{fill:#00ced8;}.cls-6{isolation:isolate;}.cls-7{fill:#fff;}.cls-8{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_8);}.cls-11,.cls-9{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_7);}.cls-10{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_6);}.cls-11{fill-opacity:0.42;}.cls-12{mix-blend-mode:soft-light;fill:url(#Degradado_sin_nombre_10);}.cls-13{fill-opacity:0.36;fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1);}.cls-14{fill:#1cb9f7;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_8",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 8",
    width: 106.53,
    height: 106.53,
    patternTransform: "translate(-74.37 -22.95)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.53 106.53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.53,
    height: 106.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 106.53,
    height: 106.53
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_7",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 7",
    width: 106.53,
    height: 106.53,
    patternTransform: "translate(-74.37 -22.95)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.53 106.53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.53,
    height: 106.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 106.53,
    height: 106.53
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_6",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 6",
    width: 106.53,
    height: 106.53,
    patternTransform: "translate(-74.37 -22.95)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.53 106.53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.53,
    height: 106.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 106.53,
    height: 106.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: 870.94,
    y1: 881.45,
    x2: 593.93,
    y2: 1344.64,
    gradientTransform: "translate(828.89 1435.56) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f1cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075b7"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 44,
    height: 44,
    patternTransform: "translate(-35 -16)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 44,
    height: 44
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fon4_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 640,
    height: 479.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "503.32 0 337.21 479.23 0 479.23 0 0 503.32 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "640 480 0 6 0 480 640 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "0 479.23 0 0 338.9 0 0 479.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "640 480 503.32 0 0 0 0 239.61 640 480"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "291.3 479.88 219.62 168.63 0 0.65 0 479.88 291.3 479.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "0 249.15 219.64 168.66 640 0 0 0 0 249.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "-0.21 0 338.68 0 219.62 168.66 -0.21 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFon4);
export default __webpack_public_path__ + "static/media/fon4_.8cc4c90b07ad42add2f8ccc44b426661.svg";
export { ForwardRef as ReactComponent };